'use client';

import './RatingStats.scss';

interface RatingStatsProps {
  totalRatings: number;
  avgStars: number;
  successCount: number;
  successRate: number;
}

export default function RatingStats({
  totalRatings,
  avgStars,
  successCount,
  successRate,
}: RatingStatsProps) {
  if (totalRatings === 0) {
    return (
      <div className="rating-stats empty">
        <p>No ratings yet. Be the first to rate this sketch!</p>
      </div>
    );
  }

  // Create array of 3 stars with fill states based on avgStars
  const renderStars = () => {
    const stars = [];
    for (let i = 1; i <= 3; i++) {
      let starClass = 'empty';
      if (avgStars >= i) {
        starClass = 'filled';
      } else if (avgStars >= i - 0.5) {
        starClass = 'half';
      }
      stars.push(
        <span key={i} className={`star ${starClass}`}>
          ★
        </span>
      );
    }
    return stars;
  };

  return (
    <div className="rating-stats">
      <div className="stats-grid">
        <div className="stat-item">
          <div className="stat-value">
            <span className="stars-container">{renderStars()}</span>
            <span className="rating-number">{avgStars.toFixed(1)}</span>
          </div>
          <div className="stat-label">{totalRatings} Rating{totalRatings !== 1 ? 's' : ''}</div>
        </div>

        <div className="stat-item">
          <div className="stat-value success-rate">
            {successRate}%
          </div>
          <div className="stat-label">{successCount}/{totalRatings} Successful</div>
        </div>
      </div>
    </div>
  );
}
